<mat-form-field mat-input-height-large-label [style.width]="width">
  <mat-label>{{ placeholder }}</mat-label>
  <input matInput [matAutocomplete]="auto" [formControl]="formControl" />
  <mat-autocomplete #auto="matAutocomplete" (opened)="onDropdownOpen()" class="overflow-hidden">
    <div *ngIf="unselectMessageKey" class="selected-items" (click)="unselectAll()">
      <mat-checkbox
        [disabled]="!selectData.length"
        class="unselect-all"
        [indeterminate]="!!selectData.length"
      >
        {{
          unselectMessageKey
            | translate: { selectedParams: selectData.length, allParams: options.length }
        }}
      </mat-checkbox>
    </div>
    <cdk-virtual-scroll-viewport
      [ngStyle]="{ height: autocompleteHeight }"
      [itemSize]="elementHeight"
      minBufferPx="1600"
      maxBufferPx="1600"
    >
      <mat-option
        [ngStyle]="{ height: elementHeight + 'px' }"
        *cdkVirtualFor="let value of filteredData | async; trackBy: autocompleteValuesTrackBy"
        [value]="value"
      >
        <div (click)="optionClicked($event, value)">
          <mat-checkbox
            [checked]="value.selected"
            [disableRipple]="true"
            (change)="toggleSelection(value)"
            (click)="$event.stopPropagation()"
          >
            <span class="value">{{ value?.viewValue }} </span>
            <span *ngIf="value?.viewValueTwo">{{
              value?.viewValueTwo ? '(' + value.viewValueTwo + ')' : ''
            }}</span>
            <span *ngIf="value?.viewValueThree" class="sub-value">{{ value?.viewValueThree }}</span>
          </mat-checkbox>
        </div>
      </mat-option>
    </cdk-virtual-scroll-viewport>
  </mat-autocomplete>
</mat-form-field>
